export type WifiSignalIcon = 'wifi' | 'medium-wifi' | 'low-wifi' | 'very-low-wifi' | 'no-wifi';

// The backend is migrating signalStrength from a 0-100 percentage scale to dBm (always
// negative). Until that rollout is complete we get either shape, so percentages are
// converted to their dBm equivalent before bucketing. Once the migration finishes this
// conversion — and the percentage branch below — can be deleted.
const percentageToDbm = (percentage: number): number => percentage / 2 - 100;

export const getWifiSignalIcon = (signalStrength: number): WifiSignalIcon => {
  const dbm = signalStrength >= 0 ? percentageToDbm(signalStrength) : signalStrength;

  if (dbm >= -60) return 'wifi';
  if (dbm >= -70) return 'medium-wifi';
  if (dbm >= -80) return 'low-wifi';
  if (dbm >= -90) return 'very-low-wifi';
  return 'no-wifi';
};
